module.exports = __webpack_public_path__ + "static/media/bannerImage1-m.119c7125.jpg";